"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterestBasedProductCashFlow = exports.CashFlow = exports.InterestCashFlowParameters = void 0;
class InterestCashFlowParameters {
    constructor() {
        this.isCapitalization = false;
        this.useAccruedInterestInGen = false;
        this.interestCalcFrequencyMultiplier = 1;
    }
}
exports.InterestCashFlowParameters = InterestCashFlowParameters;
;
;
;
;
class CashFlow {
}
exports.CashFlow = CashFlow;
class InterestBasedProductCashFlow {
}
exports.InterestBasedProductCashFlow = InterestBasedProductCashFlow;
//# sourceMappingURL=cash-flow.js.map